/* @flow */
import Reflux from "reflux";

const exported = {
    renderSpeed: Reflux.createAction("renderSpeed") as RefluxAction<[string, string, number]>,
    apiDataLoad: Reflux.createAction("apiDataLoad") as RefluxAction<[string, string, string, number]>
};

export default exported;

export const { renderSpeed, apiDataLoad } = exported;
